import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

import styles from './footer.module.scss';

export const Footer = ({ isCardsView }) => {
    return (
        <div className={isCardsView ? styles.footerCardView : styles.footer} id="footer">
            <Typography variant="body2">
                <Link className={isCardsView ? styles.footerLinkCardView : styles.footerLink} to="/">
                    Tracker System
                </Link>
                {' Copyright © ' + new Date().getFullYear() + '.'}
            </Typography>
        </div>
    );
}